import * as React from 'react';
import { useSelector } from 'react-redux';
import { prepareTrackAddressPick, trackAddressChange } from '../../../analytics';
import { getSiteType } from '../../../utils/getSiteType';
import { throttle } from 'throttle-debounce';
import { selectDeviceType } from '../../../selectors';
/**
 * Функции аналитики, требующие декорации, созданы в useCallback для оптимизации
 * */

export var useAnalytics = function useAnalytics() {
  var deviceType = useSelector(selectDeviceType); // eslint-disable-next-line react-hooks/exhaustive-deps

  var trackAddressPick = React.useCallback(prepareTrackAddressPick({
    pageType: 'EstateCalculator',
    siteType: getSiteType(deviceType)
  }), [deviceType]); // eslint-disable-next-line react-hooks/exhaustive-deps

  var trackAddressChangeThrottled = React.useCallback(throttle(400, trackAddressChange), []);
  return {
    trackAddressChangeThrottled: trackAddressChangeThrottled,
    trackAddressPick: trackAddressPick
  };
};